export function handleNumberChange(min: number, max: number, value: string) {
    if (!value || value === "") {
        return "";
    }

    if (isNaN(Number(value))) {
        return "";
    }

    let val = Number(value);

    if (val > max) {
        val = max;
    } else if (val < min) {
        val = min;
    }

    return val;
}
